module.exports = __webpack_public_path__ + "static/media/ptz_third_party.8ab83150.svg";